import React from 'react';
import Header from './Header';
import Footer from './Footer';

const PrivacyPage = () => {
    return (
        <div className="min-h-screen bg-gray-50 flex flex-col">
            <Header />
            <main className="grow max-w-4xl mx-auto px-4 py-12">
                <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12">
                    <h1 className="text-3xl font-bold text-gray-900 mb-8">Politique de Confidentialité</h1>

                    <div className="prose prose-purple max-w-none text-gray-600">
                        <section className="mb-8">
                            <h2 className="text-xl font-semibold text-gray-900 mb-4">Protection des données personnelles</h2>
                            <p>
                                Linkoo accorde une importance capitale à la confidentialité de vos données. Cette politique décrit comment nous collectons, utilisons et protégeons vos informations personnelles.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-xl font-semibold text-gray-900 mb-4">Données collectées</h2>
                            <p>
                                Nous collectons les informations que vous nous fournissez directement, notamment lors de la création de votre compte, de la modification de votre profil ou lors de vos communications avec notre support. Ces données peuvent inclure votre nom, adresse email, informations professionnelles, et coordonnées.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-xl font-semibold text-gray-900 mb-4">Utilisation des données</h2>
                            <p>
                                Vos données sont utilisées pour :
                            </p>
                            <ul className="list-disc pl-5 mt-2 space-y-1">
                                <li>Fournir et améliorer nos services</li>
                                <li>Gérer votre compte et vos préférences</li>
                                <li>Communiquer avec vous concernant nos services</li>
                                <li>Assurer la sécurité de notre plateforme</li>
                            </ul>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-xl font-semibold text-gray-900 mb-4">Vos droits</h2>
                            <p>
                                Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, de suppression et de portabilité de vos données. Pour exercer ces droits, veuillez nous contacter à contact@linkoo.be.
                            </p>
                        </section>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default PrivacyPage;
